export const ENV_CONSTANT = {
  LOCAL: 'local',
  DEVELOP: 'dev',
  UAT: 'qa',
  PRODUCTION: 'production',
};

export const PAGE_NAME = {
  PREPAY: 'prepay',
  PAID: 'paid',
  APPEALS: 'appeals',
  INQUIRIES: 'inquiries',
};

export const CLAIMS_LOOKUP_SEARCH_TYPE = {
  CLAIM_ID: 'claimId',
  CASE_ID: 'caseId',
};

export enum CLAIMS_TAB_SEARCH_QUERY_VALUES {
  'overview',
  'appeals',
  'inquiries',
  'attachments',
  'activity',
}

export enum CLAIM_TAB_VALUES {
  overview = 0,
  appeals = 1,
  inquiries = 2,
  attachments = 3,
  activity = 4,
}

export enum CLIENT_TAB_VALUES {
  invoicing = 0,
  features = 1,
  clientDetails = 2,
}

export enum CLIENTS_TAB_SEARCH_QUERY_VALUES {
  'invoicing',
  'features',
  'clientDetails',
}

export enum APPEALS_TAB_SEARCH_QUERY_VALUES {
  'overview',
  'attachments',
  'notes',
  'activity',
}

export enum INQUIRY_TAB_SEARCH_QUERY_VALUES {
  'overview',
  'attachments',
  'activity',
}

export enum RULE_TAB_SEARCH_QUERY_VALUES {
  'attachments',
  'history',
}

export enum INQUIRY_TAB_VALUES {
  overview = 0,
  attachments = 1,
  activity = 2,
}

export enum APPEALS_TAB_VALUES {
  overview = 0,
  attachments = 1,
  notes = 2,
  activity = 3,
}

export enum RULE_TAB_VALUES {
  attachments = 0,
  history = 1,
}

export enum APPEALS_LEVEL_VALUES {
  'First',
  'Second',
  'Third',
}

export enum NAV_MENU_ID_ENUM {
  claims = 1,
  documents = 2,
  invoicing = 3,
  rulespec = 4,
  clientManagement = 5,
  appealResponses = 6,
  activityLog = 7,
  support = 8,
}

export enum NAV_MENU_LABELS {
  claims = 'Claims',
  documents = 'Documents',
  invoicing = 'Invoicing',
  rulespec = 'Rule Spec',
  clientManagement = 'Client Management',
  appealResponses = 'Appeal Responses',
  activityLog = 'Activity Log',
  support = 'Help and Support',
}

export enum LEFT_NAV_INDEX {
  CLAIMS_PREPAY = '0|0',
  APPEALS_ALL = '1|0',
  APPEALS_NEW = '1|1',
  APPEALS_OPEN = '1|2',
  APPEALS_HOLD = '1|3',
  APPEALS_REOPEN = '1|4',
  APPEALS_PEND = '1|5',
}

export enum GridColumnConfigs {
  RuleGridColumnConfigs = 'rulespec.grid.columns',
  ReasonCodeGridColumnConfigs = 'reasoncode.grid.columns',
  DocumentReferencesGridColumnConfigs = 'documentreferences.grid.columns',
  //more grid names come here when saving!!
}
